import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Button } from 'common/components/layout';
import { sendToHostedPayment } from 'redux/cart/actions';

import HostedPaymentRedirectHiddenForm from './HostedPaymentRedirectHiddenForm';

const Payment = (props) => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [redirectObj, setRedirectObj] = useState();
  const handleSendToHostedPayment = () => {
    setIsSubmitting(true);
    const redirectFunction = (response) => {
      setRedirectObj(response);
    };
    dispatch(sendToHostedPayment(redirectFunction));
  };

  const handleBack = (e) => {
    e.preventDefault();
    props.onEdit('shipping');
  };

  if (redirectObj) {
    return <HostedPaymentRedirectHiddenForm redirectObj={redirectObj} />;
  }
  return (
    <>
      <h3>Payment method</h3>
      <p>All transactions are secure and encrypted.</p>
      <p>&nbsp;</p>
      <div style={{ textAlign: 'center' }}>
        <Button
          type="button"
          className="c7-button"
          disabled={isSubmitting}
          onClick={handleSendToHostedPayment}
        >
          Proceed to Payment
        </Button>
      </div>
      <p>&nbsp;</p>

      <div className="c7-checkout__content__buttons">
        <a href="#" aria-label="Return to shipping method" onClick={handleBack}>
          Return to shipping method
        </a>
      </div>
    </>
  );
};

export default Payment;
